import { ResponseType, TClientErrorResponse } from "@sphtech/web2-core/ssr";
import type { ReactElement } from "react";
import { ActionFunctionArgs } from "react-router";

export function meta() {
  return [{ title: "Page not found" }];
}

export default function NotFound(): ReactElement {
  return (
    <>
      <div className="flex flex-col items-center mt-[150px]">
        <h1 className="text-md lg:text-lg">
          Sorry, the page you visited no longer exists.
        </h1>
        <p className="text-md lg:text-lg">
          Please visit our{" "}
          <span>
            <a href="/" className="text-red-100">
              Home Page
            </a>
          </span>
        </p>
      </div>
    </>
  );
}

/**
 * This action handler is included to ensure that the catch-all route
 * can safely handle non-GET requests (e.g. POST, PUT, DELETE).
 *
 * In Remix v3 / React Router v7, submitting a non-GET request to a route
 * without an `action()` will cause a runtime error, even if the route is
 * meant to handle unmatched paths like a 404 page.
 *
 * By including this no-op `action()`, we prevent those crashes and
 * allow the app to gracefully handle unexpected submissions or
 * form posts to unknown URLs.
 */
export function action({ request }: ActionFunctionArgs) {
  console.debug(
    `[404 action] Received unexpected ${request.method} request to ${request.url}`,
  );
  return { ok: true };
}

export function loader(): TClientErrorResponse<string> {
  return {
    type: ResponseType.CLIENT_ERROR,
    statusCode: 404,
    payload: "404 page loader executed - route not found",
  };
}
